import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function LoadingCircle() {
  return (
    <Box sx={{ display: "flex" ,placeContent:'center', marginTop:'10px'}}>
      <CircularProgress size={30} color='info'/>
    </Box>
  );
}
